import { RouteRecordRaw } from "vue-router";
import LoginView from "../views/LoginView.vue";

const route: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    meta: { layout: "empty" },
    component: LoginView,
  },
  {
    path: "/home",
    name: "home",
    meta: { layout: "main" },
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/media",
    name: "media",
    meta: { layout: "main" },
    component: () => import("../views/submenu/MediaView.vue"),
  },
  {
    path: "/staff-connection",
    name: "staff-connection",
    meta: { layout: "main" },
    component: () => import("../views/submenu/StaffConnection.vue"),
  },
  {
    path: "/hello",
    name: "hello",
    meta: { layout: "empty" },
    component: () => import("../views/HelloView.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: { layout: "empty" },
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/cinema",
    component: () => import("../views/CinemaView.vue"),
    children: [
      {
        path: "",
        name: "cinema",
        meta: { layout: "main" },
        component: () => import("../views/cinema/CinemaHome.vue"),
      },
      {
        path: "movie",
        name: "movie",
        meta: { layout: "main" },
        component: () => import("../views/cinema/MovieCard.vue"),
      },
    ],
  },
  {
    path: "/map",
    name: "map",
    meta: { layout: "empty" },
    component: () => import("../views/MapPage.vue"),
  },
  {
    path: "/weather",
    name: "weather",
    meta: { layout: "main" },
    component: () => import("../views/WeatherPage.vue"),
  },
  {
    path: "/timetable",
    name: "timetable",
    meta: { layout: "main" },
    component: () => import("../views/TimeTablePage.vue"),
  },
  {
    path: "/info",
    name: "info",
    meta: { layout: "main" },
    component: () => import("../views/InfoPage.vue"),
  },
  {
    path: "/hotel-specification",
    name: "hotel-specification",
    meta: { layout: "main" },
    component: () => import("../views/HotelSpecificationView.vue"),
  },
  {
    path: "/route-info",
    name: "route-info",
    meta: { layout: "main" },
    component: () => import("../views/RouteInfoView.vue"),
  },
  {
    path: "/wiki",
    name: "wiki",
    meta: { layout: "main" },
    component: () => import("../views/WikiMap.vue"),
  },
  {
    path: "/staff",
    name: "staff",
    meta: { layout: "main" },
    component: () => import("../views/StaffPage.vue"),
  },
  {
    path: "/settings",
    name: "Settings",
    meta: { layout: "main" },
    component: () => import("../views/SettingsPage.vue"),
  },
  {
    path: "/internet",
    name: "internet",
    meta: { layout: "main" },
    component: () => import("../views/InternetView.vue"),
  },
  {
    path: "/instruction",
    name: "instruction",
    meta: { layout: "main" },
    component: () => import("../views/submenu/InstructionView.vue"),
  },
  {
    path: "/excursions",
    name: "excursions",
    meta: { layout: "main" },
    component: () => import("../views/ExcursionView.vue"),
  },
  {
    path: "/bars",
    component: () => import("../views/BarView.vue"),
    children: [
      {
        path: "", // /bars - выбор бара
        name: "bars",
        meta: { layout: "main" },
        component: () => import("../views/bars/BarMenuList.vue"),
      },
      {
        path: ":barId/categories", // /bars/123/categories
        name: "bar-categories", // Категории конкретного бара
        meta: { layout: "main" },
        component: () => import("../views/bars/BarCategorys.vue"),
      },
      {
        path: ":barId/categories/:categoryId", // /bars/123/categories/456
        name: "bar-category-items", // Блюда в категории бара
        meta: { layout: "main" },
        component: () => import("../views/bars/BarCategoryItems.vue"),
      },
    ],
  },
  {
    path: "/menu",
    name: "menu",
    meta: { layout: "main" },
    component: () => import("../views/MenuSheet.vue"),
  },
  {
    path: "/channels",
    name: "channels",
    meta: { layout: "main" },
    component: () => import("../views/ChannelsView.vue"),
  },
  {
    path: "/smart-home",
    name: "smart-home",
    meta: { layout: "main" },
    component: () => import("../views/SmartHomeView.vue"),
  },
  {
    path: "/alarm-clock",
    name: "alarm-clock",
    meta: { layout: "main" },
    component: () => import("../views/AlarmView.vue"),
  },
  {
    path: "/smart-share",
    name: "smart-share",
    meta: { layout: "main" },
    component: () => import("../views/SmartShareView.vue"),
  },
  {
    path: "/wifi",
    name: "wifi",
    meta: { layout: "main" },
    component: () => import("../views/WiFiQrcode.vue"),
  },
  {
    path: "/player",
    name: "player",
    meta: { layout: "empty" },
    component: () => import("../views/PlayerView.vue"),
  },
  {
    path: "/audio",
    name: "audio",
    meta: { layout: "main" },
    component: () => import("../views/audio-next/AudioViewNext.vue"),
  },
  {
    path: "/books",
    name: "books",
    meta: { layout: "main" },
    component: () => import("../views/BooksView.vue"),
  },
  {
    path: "/cart",
    name: "cart",
    meta: { layout: "main" },
    component: () => import("../views/Cart.vue"),
  },
  {
    path: "/404",
    name: "NotFound",
    meta: { layout: "main" },
    component: () => import("../views/NotFoundView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: { layout: "main" },
    component: () => import("../views/NotFoundView.vue"),
  },
];

export default route;
